import React, { FC } from 'react';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionOrderSearchItem } from '@interfaces/search';
import ProductionOrderContentWrapper from './components/ProductionOrderContentWrapper';
import { useHandleNavigationContextHeader } from '@v2/pages/common/hooks/useHandleNavigationContextHeader';
import { LevelSubScreen } from '@v2/pages/common/enums';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface ProductionOrderDetailsProductionOrderDocumentsProps extends ProductionOrderScreenProps {
  productionOrderId: number | null;
  productionOrders: ReducerEntityWithLoadingState<ProductionOrderSearchItem[]>;
}

const ProductionOrderDetailsProductionOrderDocumentsComponent: FC<ProductionOrderDetailsProductionOrderDocumentsProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  productionOrderId,
  productionOrders,
}) => {
  const title = useTitle();
  const { activeLevelSubScreenName } = useHandleNavigationContextHeader();

  const productionOrder = productionOrders.data?.[0];
  const loading = !productionOrders.wasLoaded;

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <ProductionOrderContentWrapper
      activeLevelSubScreenName={activeLevelSubScreenName as LevelSubScreen}
      loading={loading}
      productionOrder={productionOrder}
    >
      <DetailsPageWrapper title={title.productionOrder}>
        {productionOrderId != null && (
          <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
            <ImagesDocumentsContent documentRetrieveId={productionOrderId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOrder} />
          </View>
        )}
      </DetailsPageWrapper>
    </ProductionOrderContentWrapper>
  );
};

const ProductionOrderDetailsProductionOrderDocuments = connect(
  ({ details: { productionOrderId, productionOrders } }) => ({ productionOrderId, productionOrders }),
  {
    productionOrdersSearch,
    updateHeaderConfig,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
  }
)(ProductionOrderDetailsProductionOrderDocumentsComponent);

export { ProductionOrderDetailsProductionOrderDocuments };
